export default function ProjectionReports({year, status}) {
    return (
        <>
                <div>Projection reports is in progress</div>
        </>
    )
}
